import { automationBaseAnalyticsProperties } from '@apps/web/components/automations/automation_analytics';
import { type CoordinatorAutomationRead } from '@apps/web/components/automations/types';

export function coordinatorAutomationProperties({
    automation,
    organizationId,
}: {
    readonly automation: CoordinatorAutomationRead;
    readonly organizationId: string;
}): Record<string, unknown> {
    return {
        ...automationBaseAnalyticsProperties({ organizationId }),
        automation_id: automation.id,
        trigger_type: automation.trigger_type,
        schedule_kind: automation.schedule.kind,
        enabled: automation.enabled,
        run_count: automation.run_count,
        failed_count: automation.failed_count,
    };
}
